import { Property } from 'common/types';

export const initialProperty: Property = {
    id: null,
    hashId: '',
    name: '',
    description: null,
    division: null,
    typeId: '',
    categorization: null,
    rawAddress: '',
    isParent: false,
    stdAddress: '',
    stdDeliveryLine: '',
    stdLastLine: '',
    stdPrimaryNumber: '',
    stdStreetName: null,
    stdStreetPreDirection: null,
    stdStreetPostDirection: null,
    stdStreetSuffix: null,
    stdSecondaryNumber: null,
    stdSecondaryDesignator: null,
    stdExtraSecondaryDesignator: null,
    stdExtraSecondaryNumber: null,
    stdCity: '',
    stdRegion: '',
    stdPostalCode: '',
    stdPostalCodePlus4: null,
    stdCounty: '',
    stdCountry: '',
    rdi: null,
    multiFamily: false,
    standardized: false,
    geocoded: false,
    notes: [],
    comments: null,
    photos: null,
    latitude: 0,
    longitude: 0,
    timezone: '',
    parentPropertyId: null,
    clientId: null,
    extId: null,
    extRegion: null,
    extReferenceNumber1: null,
    extReferenceNumber2: null,
    extMarket: null,
    sqft: null,
    yearBuilt: null,
    stories: null,
    bedrooms: null,
    bathrooms: null,
    acquisitionDate: null,
    folderId: '',
    primaryPreferredContractorId: null,
    secondaryPreferredContractorId: null,
    propertyProfileId: null,
    statusId: '',
    occupied: false,
    serviceBranch: null,
    serviceRegion: null,
    homeOwnerPrice: null,
    numberOfSystems: 0,
    created: '',
    updated: '',
    client: null,
    clientName: '',
    activePropertyProfile: null,
    children: [],
    workOrders: [],
    histories: [],
    hasEquipmentWarrantyAssets: false,
    folder: {
        folderAttachments: [],
    },
};
